import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { emailTypeOptions, LanguageOptions } from 'src/app/@Consts';
import { IHotel } from 'src/app/@Interfaces';
import { EmailService, HotelService } from 'src/app/@Services';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../../@Components/@common/input/input.component';
import { SelectComponent } from '../../@Components/@common/select/select.component';
import { CheckboxComponent } from '../../@Components/@common/checkbox/checkbox.component';

@Component({
    selector: 'email',
    templateUrl: './email.dialog.html',
    styleUrls: ['./email.dialog.scss'],
    imports: [
        MatIcon,
        FormsModule,
        InputComponent,
        SelectComponent,
        CheckboxComponent,
    ],
})
export class EmailDialog {
  constructor(
    private matDialogRef: MatDialogRef<EmailDialog>,
    private hotelService: HotelService,
    private emailService: EmailService,
  ) {}

  protected langOptions = LanguageOptions;
  protected emailTypeOptions = emailTypeOptions;

  public recipients: any[];
  public csv: string[][] = [];
  public form = {
    subject: '',
    emailType: 'promo',
    recipients: [],
  };
  protected selectedHotels: string[][] = [];
  protected allHotels: boolean = false;
  protected paidHotels: boolean = false;
  protected freeHotels: boolean = false;

  public sendEmails(): void {
    this.csv.forEach((recipient: string[]) => {
      this.form.recipients.push({ email: recipient[1], id: recipient[2] });
    });
    this.selectedHotels.forEach((hotel: string[]) => {
      this.form.recipients.push({ email: hotel[1], id: hotel[2] });
    });
    this.emailService
      .sendEmails(this.form)
      .then((response: { email: string; error: any }[]) => {
        if (response.length)
          alert('failed emails: ' + JSON.stringify(response));
        this.closePanel();
      })
      .catch(() => {
        console.log('error sending emails');
      });
    this.form.recipients = [];
  }

  public onFileSelected(event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const csvData = reader.result as string;
      const rows = csvData
        .split('\n')
        .map((row) => row.split(','))
        .filter((row) => row.length > 1);

      this.csv = rows;
    };

    reader.readAsText(file);
  }

  public selectCSV(): void {
    document.getElementById('recipients').click();
  }

  public clearRecipients(): void {
    this.csv = [];
  }

  public toggleAllHotels(check: boolean): void {
    if (!check) {
      this.selectedHotels = [];
      this.paidHotels = false;
      this.freeHotels = false;
      return;
    }
    this.hotelService.hotels.forEach((hotel: IHotel) => {
      if (!hotel.active) return;

      const hotelData = [
        hotel.hotel_name,
        hotel.email,
        hotel.hotel_id.toString(),
      ];
      this.selectedHotels.push(hotelData);
    });
    this.paidHotels = true;
    this.freeHotels = true;
  }

  public togglePaidHotels(check: boolean): void {
    if (!check && !this.freeHotels) {
      this.selectedHotels = [];
      this.allHotels = false;
      return;
    }

    if (!check && this.freeHotels) {
      this.selectedHotels = [];
      this.allHotels = false;
      this.hotelService.hotels.forEach((hotel: IHotel) => {
        if (!hotel.active || hotel.net_price) return;

        const hotelData = [
          hotel.hotel_name,
          hotel.email,
          hotel.hotel_id.toString(),
        ];
        this.selectedHotels.push(hotelData);
      });
      return;
    }
    this.hotelService.hotels.forEach((hotel: IHotel) => {
      if (!hotel.active || !hotel.net_price) return;

      const hotelData = [
        hotel.hotel_name,
        hotel.email,
        hotel.hotel_id.toString(),
      ];
      this.selectedHotels.push(hotelData);
    });
    if (this.freeHotels) this.allHotels = true;
  }

  public toggleFreeHotels(check: boolean): void {
    if (!check && !this.paidHotels) {
      this.selectedHotels = [];
      this.allHotels = false;
      return;
    }

    if (!check && this.paidHotels) {
      this.selectedHotels = [];
      this.allHotels = false;
      this.hotelService.hotels.forEach((hotel: IHotel) => {
        if (!hotel.active || !hotel.net_price) return;

        const hotelData = [
          hotel.hotel_name,
          hotel.email,
          hotel.hotel_id.toString(),
        ];
        this.selectedHotels.push(hotelData);
      });
      return;
    }
    this.hotelService.hotels.forEach((hotel: IHotel) => {
      if (!hotel.active || hotel.net_price) return;

      const hotelData = [
        hotel.hotel_name,
        hotel.email,
        hotel.hotel_id.toString(),
      ];
      this.selectedHotels.push(hotelData);
    });
    if (this.paidHotels) this.allHotels = true;
  }

  public closePanel(): void {
    this.matDialogRef.close();
  }
}
